
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sdks/python",
      function () {
        return require("private-next-pages/sdks/python.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sdks/python"])
      });
    }
  